import { React } from "react";
import { useSelector } from "react-redux";
import ProgressStep from "./ProgressStep";

function ProgressSteps() {
  // get current request state
  const currentFormStep = useSelector((state) => state.configurator.FormStep);
  const currentRequest = useSelector((state) => state.configurator.ConfiguratorRequest);
  const formSteps = useSelector(
    (state) => state.configurator.FormStepComponents
  );

  const activeStep = formSteps.filter(item =>  (currentFormStep === item.stepName) );
  const visibleSteps = formSteps.filter(item => item.stepTabVisible);
  const uncompletedSteps = visibleSteps.filter(item => (!item.stepCompleted));
  let currentProgress = ( (visibleSteps.length - (uncompletedSteps.length) ) * 100 / (visibleSteps.length - 1));

  return (
    <div className="row">
      <div className="col-12 col-lg-12">
        <p className="mobile-step-title">{activeStep[0].stepTabLabel}</p>
        <div className="steps">
          <progress id="progress" value={currentProgress} max="100"></progress>
          {formSteps.map((step) => (
            <ProgressStep
              key={step.stepName}
              current={currentFormStep === step.stepName}
              step={step}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProgressSteps;
